// extracted by mini-css-extract-plugin
export var actionButton = "_z6-2";
export var card = "_z6-0";
export var disambiguationList = "_z6-3";
export var errorCard = "_z6-4";
export var row = "_z6-1";